"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.libraryVersion = void 0;
var package_json_1 = require("../package.json");
/**
 * Mockable helper to return the current library version
 * @returns Current library version
 */
var libraryVersion = function () { return package_json_1.version; };
exports.libraryVersion = libraryVersion;
//# sourceMappingURL=version.js.map